export type ProgressBarProps = {
  totalSteps: number;
  currentStep: number;
};

export type DesktopProgressBarProps = ProgressBarProps & {
  // in seconds
  durationAnimation: number;
};

export enum EStepDotStatus {
  TODO = 'todo',
  CURRENT = 'current',
  DONE = 'done',
  COMPLETED = 'completed',
}
